import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker for offline support + installability (PWA).
// onUpdate: called when a new version is installed. We skip the waiting phase
// so the updated worker activates immediately, then reload to serve fresh files.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Notify the app that an update is available instead of reloading automatically
    const event = new CustomEvent('sw-update-available', { detail: registration });
    window.dispatchEvent(event);
  },
});

